import React from 'react'
import LoaderImg from 'assets/img/loaders/loader.svg'

const LoaderSection = () => {
  return (
    <div className="text-center">
      <img style={{width: '50px'}} src={LoaderImg} alt="loader svg"/>
    </div>
  )
}

export default LoaderSection
